import { Card, CardContent } from '@/components/ui/card';
import { Weight, Activity, TrendingUp, Dumbbell } from 'lucide-react';

export default function MeasurementSummaryCards({ latest }) {
    if (!latest) return null;

    const items = [
        { label: 'Peso', value: latest.weight ? `${latest.weight} kg` : '-', icon: Weight },
        { label: 'IMC', value: latest.bmi ?? '-', icon: Activity },
        { label: 'Grasa corporal', value: latest.body_fat_percentage ? `${latest.body_fat_percentage}%` : '-', icon: TrendingUp },
        { label: 'Masa muscular', value: latest.muscle_mass_kg ? `${latest.muscle_mass_kg} kg` : '-', icon: Dumbbell },
    ];

    return (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-6">
            {items.map((item) => (
                <Card key={item.label} className="bg-[#0a0a0a] border-hairline-dark">
                    <CardContent className="p-4">
                        <div className="flex items-center gap-3">
                            <div className="h-10 w-10 bg-white/10 rounded-full flex items-center justify-center">
                                <item.icon className="h-5 w-5 text-white" />
                            </div>
                            <div>
                                <p className="text-xs text-white/60 uppercase tracking-wider">{item.label}</p>
                                <p className="text-lg font-bold text-white">{item.value}</p>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
